import script from "./global-groups.vue?vue&type=script&setup=true&lang=js"
export * from "./global-groups.vue?vue&type=script&setup=true&lang=js"

import "./global-groups.vue?vue&type=style&index=0&id=0dddfa54&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dddfa54"]])

export default __exports__